module.exports = __webpack_public_path__ + "media/C_game_start.9ca6f3ba.mp3";